import { render } from "./DefSlideModal.vue?vue&type=template&id=648a53c4&scoped=true"
import script from "./DefSlideModal.vue?vue&type=script&lang=js"
export * from "./DefSlideModal.vue?vue&type=script&lang=js"

import "./DefSlideModal.vue?vue&type=style&index=0&id=648a53c4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-648a53c4"]])

export default __exports__